const branding = 'Brisbane City Council';
export default branding;


// WEBPACK FOOTER //
// ./src/data/branding.js